import React from 'react';
import { REGULARIZATION_STATUS } from '../constants';
import { buildQueryString, formatDisplayDate } from '../darwinRecordUtils';

const DarwinRegularizationCard = ({ item, listStatus, mode, baseUrl, history }) => {
  const statusMeta = REGULARIZATION_STATUS[item.status] || {
    text: 'Unknown',
    className: 'darwin-status-default',
  };
  const requestType = item.type || 'REGULARIZATION';

  const detailsPath = buildQueryString({
    id: item.id,
    type: requestType,
    list_status: listStatus,
    mode,
  });

  return (
    <article className="darwin-regularization-card">
      <span
        className={`darwin-regularization-card__badge ${statusMeta.className}`}
      >
        {statusMeta.text}
      </span>
      <div className="darwin-regularization-card__body">
        <div>
          <p className="darwin-regularization-card__name">
            {item.requestorName || '—'}
          </p>
          {item.requestorEmail ? (
            <p className="darwin-regularization-card__email">{item.requestorEmail}</p>
          ) : null}
        </div>
        <div className="darwin-regularization-card__row">
          <span className="darwin-regularization-card__row-label">Requested for</span>
          <span className="darwin-regularization-card__row-value">
            {formatDisplayDate(item.requestedForDate)}
          </span>
        </div>
        <div className="darwin-regularization-card__row">
          <span className="darwin-regularization-card__row-label">Requested on</span>
          <span className="darwin-regularization-card__row-value">
            {formatDisplayDate(item.requestedOnDate)}
          </span>
        </div>
        <div className="darwin-regularization-card__row">
          <span className="darwin-regularization-card__row-label">Type</span>
          <span className="darwin-regularization-card__row-value">
            {requestType === 'WOOO' ? 'Work Out Of Office' : 'Regularization'}
          </span>
        </div>
      </div>
      <div className="darwin-regularization-card__footer">
        <button
          type="button"
          className="darwin-regularization-card__view-link"
          onClick={() =>
            history.push(`${baseUrl}/darwin-record/regularizations/details${detailsPath}`)
          }
        >
          {mode === 'action' ? 'Review' : 'View'}
        </button>
      </div>
    </article>
  );
};

export default DarwinRegularizationCard;
